export enum LoadingError {
  NotFound = 'NotFound',
  Other = 'Other'
}
